<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
.mint-indicator-wrapper,.mint-indicator-mask {
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue